<div nz-row nzJustify="center" [nzGutter]="{ md: 24 }">

    <div nz-col nzSpan="24">
        <nz-card style="max-width: 395px; display: block; margin: 0 auto;">
            <img src="../../assets/img/logomarca_1.png" class="logomarca" style="width:80%" alt="logo">

            <form nzLayout="vertical" style="margin-top:20px!important;" nz-form [formGroup]="validateForm" class="login-form" (ngSubmit)="submitForm()">
                <nz-form-item>
                    <label for="">E-mail:</label>
                    <nz-form-control nzHasFeedback nzErrorTip="Informe um e-mail válido!">

                        <nz-input-group nzPrefixIcon="user">

                            <input type="email" nz-input formControlName="email" placeholder="Digite o seu e-mail" />
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <label for="">Senha:</label>
                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">

                        <nz-input-group nzPrefixIcon="lock">
                            <input type="password" nz-input formControlName="password" placeholder="Senha" />
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>
                <button nz-button nzBlock class="login-form-button login-form-margin" [nzType]="'primary'">Acessar</button>

                <div nz-row class="login-form-margin" style="margin-top:10px;">
                    <div nz-col [nzSpan]="24">
                        <a class="login-form-forgot" [routerLink]="['/login/reset/password']" routerLinkActive="router-link-active">Esqueci minha senha</a>
                    </div>
                </div>
            </form>
        </nz-card>
    </div>
</div>